module.exports = __webpack_public_path__ + "static/media/dropdown.662b6bcb.svg";